export default {
  title: 'Ative as notificações para ofertas e novidades exclusivas',
  description: 'Receba atualizações em tempo real. Acompanhe a entrega. Promoções e vantagens exclusivas.',
  buttons: {
    confirm: 'Ativar',
    cancel: 'Agora não',
  },
};
